
export type NotFoundErrorResponse = {
  error?: string;
  message?: string;
  timestamp?: string;
};
